import request from '@/utils/request'
import URL from './urlTranslator'

// 获取汇率列表
export function getRateList(params) {
  return request({
    url: URL.mdm.rate.rateInfo,
    method: 'get',
    params
  })
}

// 新增汇率
export function addRate(data) {
  return request({
    url: URL.mdm.rate.rateInfo,
    method: 'post',
    data
  })
}

// 编辑汇率
export function updateRate(data) {
  return request({
    url: URL.mdm.rate.rateInfo,
    method: 'put',
    data
  })
}

// 复制汇率
export function copyRate(data) {
  return request({
    url: URL.mdm.rate.copyrRateInfo,
    method: 'put',
    data
  })
}

// 确认复制汇率
export function confirmCopyRate(data) {
  return request({
    url: URL.mdm.rate.confirmCopyRateInfo,
    method: 'put',
    data
  })
}

// 删除汇率
export function batchDelRate(data) {
  return request({
    url: URL.mdm.rate.rateInfo,
    method: 'delete',
    data
  })
}

// 根据原币种，目标币种，汇率日期查询汇率
export function queryRateListByCurrencyAndDate(requestBody) {
  return request({
    url: URL.mdm.rate.getRateListByCurrencyAndDate,
    method: 'post',
    data: requestBody
  })
}

// 查询所有汇率-生效日期
export function getRatePeriodList(data) {
  return request({
    url: URL.mdm.rate.queryRatePeriod,
    method: 'post',
    data
  })
}

// 新增汇率-生效日期
export function addRatePeriod(data) {
  return request({
    url: URL.mdm.rate.ratePeriod,
    method: 'post',
    data
  })
}

// 获取汇率详情
export function detailRatePeriod(data) {
  return request({
    url: URL.mdm.rate.detailRatePeriod,
    method: 'post',
    data
  })
}

// 修改汇率-生效日期
export function updateRatePeriod(data) {
  return request({
    url: URL.mdm.rate.ratePeriod,
    method: 'put',
    data
  })
}

// 删除汇率-生效日期
export function batchDelRatePeriod(data) {
  return request({
    url: URL.mdm.rate.ratePeriod,
    method: 'delete',
    data
  })
}

// 复制汇率-生效日期
export function copyRatePeriod(data) {
  return request({
    url: URL.mdm.rate.copyrRatePeriodInfo,
    method: 'post',
    data
  })
}

// 初始化历史汇率-生效日期
export function initRatePeriod(data) {
  return request({
    url: URL.mdm.rate.initRatePeriod,
    method: 'post',
    data
  })
}

// 获取汇率缓存月份
export function getRateCacheRange() {
  return request({
    url: URL.mdm.rate.getRateCacheRange,
    method: 'post'
  })
}

// 设置汇率缓存月份
export function saveRateCacheRange(data) {
  return request({
    url: URL.mdm.rate.saveRateCacheRange,
    method: 'post',
    data
  })
}

// 删除汇率-分公司
export function batchDelRateBranch(data) {
  return request({
    url: URL.mdm.rate.batchDelRateBranch,
    method: 'post',
    data
  })
}

// 设置对下级子公司生效
export function setEnabledChild(data) {
  return request({
    url: URL.mdm.rate.setEnabledChild,
    method: 'post',
    data
  })
}
